export default () => ({
  grid_container: {
    margin: '0 -10px',
  },
});
